import React from 'react';
import { Marker } from '../../../../../lib/Map';
import { isDriverDelayed } from './utils';
import { getDispatchDriverMarker } from '../../../../mapComponents/mapHelper';
import { formatDriverLocation } from './utils';
import { observer, inject } from 'mobx-react';

const getFilteredDriverIds = ({
  routesWithFilteredStops,
  showAllDrivers,
  selectedDispatchDriverIdList,
  filteredDriversOnMap
}) => {
  if (routesWithFilteredStops.length === 0) {
    const isDriverWithNoRouteSelected = selectedDispatchDriverIdList.length > 0;
    // Show all drivers if showAllDrivers is true or no specific drivers are selected
    if (showAllDrivers || isDriverWithNoRouteSelected === false) {
      return filteredDriversOnMap.map((driver) => driver.driverId.toUpperCase());
    }
    // Show only selected drivers if they have no routes assigned
    return filteredDriversOnMap
      .filter((driver) => selectedDispatchDriverIdList.includes(driver.driverId.toUpperCase()))
      .map((driver) => driver.driverId.toUpperCase());
  }

  // If routes are filtered and showAllDrivers is true, show all drivers
  if (showAllDrivers) {
    return filteredDriversOnMap.map((driver) => driver.driverId.toUpperCase());
  }

  // Otherwise, return the drivers associated with the filtered routes
  return routesWithFilteredStops.map((route) => route.driverId.toUpperCase());
};


const DriverMarkers = ({
  DispatchStore,
  isDriverRouteShown,
  theme,
  onDriverIconClick,
  openMessageChatBox,
  onShowActualRouteToggleClick,
  showActualRoute,
  enableDriverActualRoute
}) => {
  const {
    showAllDrivers,
    routesWithFilteredStops,
    filteredDriversOnMap,
    showDriverLabel,
    driverLocations,
    selectedDispatchDriverIdList
  } = DispatchStore;

  const filteredDriverIds = getFilteredDriverIds({
    routesWithFilteredStops,
    showAllDrivers,
    selectedDispatchDriverIdList,
    filteredDriversOnMap,
  });

  return Object.entries(driverLocations).reduce((acc, [driverId, locationData]) => {
    if (!filteredDriverIds.includes(driverId) || !locationData.lat || !locationData.lng) {
      return acc;
    }

    const driverData = DispatchStore.getCurrentDriver(driverId);
    if (!driverData) {
      return acc;
    }
    return [
      ...acc,
      <Marker
        position={formatDriverLocation(locationData)}
        zIndex={isDriverRouteShown(driverId) ? 1 : 0}
        key={driverId}
        data={{locationData, driverId}}
        onClick={onDriverIconClick}
      >
        {getDispatchDriverMarker({
          data: {...driverData, driverId},
          isDelayed: isDriverDelayed(driverData),
          showDriverLabel: isDriverRouteShown(driverId) || showDriverLabel,
          theme,
          onMessageIconClick: openMessageChatBox,
          onShowActualRouteToggleClick,
          showActualRoute,
          enableDriverActualRoute
        })}
      </Marker>
    ];
  }, []);
};

export default inject('DispatchStore')(observer(DriverMarkers));
